import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import axios from 'src/utils/axios';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Skeleton from '@mui/material/Skeleton';

const useStyles = makeStyles({
    tableHead: {
        fontWeight: 'bold',
        borderLeft: '1px solid #ddd',
    },
    tableRow: {
        borderLeft: '1px solid #ddd',
    }
});

const ReceiptStatusHistory = () => {
    const { ReceiptNumber } = useParams();
    const history = useHistory();
    const classes = useStyles();

    const [receiptStatusHistoryData, setReceiptStatusHistoryData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getReceiptStatusHistoryInformation();
    }, [])

    const handleGoBack = () => {
        history.goBack();
    };

    const getReceiptStatusHistoryInformation = () => {
        axios.get(`GetReceiptStatusHistoryInformation/${ReceiptNumber}`)
            .then((response) => {
                var data = response.data;
                setReceiptStatusHistoryData(data);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }


    return (
        <Grid container spacing={1} style={{ overflow: 'auto', maxHeight: '90vh' }}>
            <Grid item xs={false} sm={false} md={2} />
            <Grid item xs={12} sm={12} md={8}>
                <Paper elevation={3} style={{ marginTop: 20 }}>
                    <TableContainer component={Paper}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                    <TableCell colSpan={8}>
                                        <Grid container alignItems="center">
                                            <Grid item xs={1}>
                                                <IconButton onClick={() => { handleGoBack(); }} style={{ color: '#fff' }}>
                                                    <ArrowBackIcon />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Typography variant="h5" align="center" style={{ color: '#fff' }}>
                                                    Fiş Durum Geçmişi
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1} />
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Fiş No
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Kullanıcı
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Durum
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        İşlem Tarihi
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(4)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={150} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    receiptStatusHistoryData.length > 0 && receiptStatusHistoryData.map((receipt, index) => (
                                        <TableRow key={index}>
                                            <TableCell >{receipt.FIS_NO}</TableCell>
                                            <TableCell style={{ border: '1px solid #ddd' }}>{receipt.ADSOYAD}</TableCell>
                                            <TableCell style={{ borderRight: '1px solid #ddd' }}>{receipt.ACIKLAMA}</TableCell>
                                            <TableCell >{moment(receipt.TARIH).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item xs={false} sm={false} md={2} />
        </Grid>
    );
};

export default ReceiptStatusHistory;